// Copyright ©️ 2026 eVolve MEP, LLC

import React from 'react';

import { type StrongOmit, useEvolvePost, type WorkOrderItem, type WorkOrder } from '@evolvemep/api-ts';

import {
  type EditItemPopoverProps,
  EditItemPopover,
} from 'modules/Shop/WorkOrders/WorkOrderDetail/Items/EditItemPopover';

type Props = StrongOmit<EditItemPopoverProps, 'onSubmit'> & {
  workOrder: WorkOrder;
  parentWorkOrderItem?: WorkOrderItem;
  onItemAdded?: (item: WorkOrderItem) => void;
};

export const AddWriteInItemToWorkOrderPopover = ({ onItemAdded, workOrder, parentWorkOrderItem, ...props }: Props) => {
  const { apiCall: addWriteInItemToWorkOrder } = useEvolvePost('shop/workOrder/item/writeIn');

  return (
    <EditItemPopover
      onSubmit={async (item) => {
        await addWriteInItemToWorkOrder({
          workOrderId: workOrder.workOrderId,
          parentWorkOrderItemId: parentWorkOrderItem?.workOrderItemId,
          ...item,
        }).then(onItemAdded);
      }}
      {...props}
    />
  );
};
